import React from "react";
import { api } from "@/lib/api";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    console.error("UI crash caught:", error, info?.componentStack);
    api.post("/client-error", { message: String(error?.message || error).slice(0, 500), stack: String(error?.stack || "").slice(0, 3000),
      component: String(info?.componentStack || "").slice(0, 3000), path: window.location.pathname }).catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex-1 min-h-[60vh] bg-[#0A0A0A]/80 text-zinc-200 flex flex-col items-center justify-center gap-4 p-6 text-center" data-testid="error-boundary">
        <div className="font-heading text-xl">Something went wrong on this screen</div>
        <p className="text-sm text-zinc-500 max-w-md">Your prompt drafts are saved. Try again to continue where you left off.</p>
        <p className="text-[11px] font-mono text-zinc-600 max-w-lg break-words" data-testid="error-boundary-detail">{String(this.state.error?.message || this.state.error).slice(0, 300)}</p>
        <button className="ax-generate h-10 px-6" onClick={() => this.setState({ error: null })} data-testid="error-boundary-retry">Try again</button>
      </div>
    );
  }
}
